import { I18nProvider } from '@lingui/react'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'

import store from 'shared/store'
import { ShopAndRuntimeConfigContext } from 'views/components/templates/helpers'
import Cart from 'views/containers/spa/Cart'

export default ({ container, i18n }) => {
  const { CartInitialState } = store.getComponentInitialState()
  const reduxStore = store.getStore()
  const { publicConfig, pageProperties } = store.getPublicRuntimeConfig()

  hydrate(
    <ShopAndRuntimeConfigContext.Provider
      value={{ publicConfig, pageProperties }}
    >
      <Provider store={reduxStore}>
        <I18nProvider i18n={i18n}>
          <Cart {...CartInitialState} />
        </I18nProvider>
      </Provider>
    </ShopAndRuntimeConfigContext.Provider>,
    container
  )
}
